import { render } from "./dates.vue?vue&type=template&id=ecab6c36"
import script from "./dates.vue?vue&type=script&lang=js"
export * from "./dates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/grgnd.webweb.works/client/grapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__